import React from 'react';
import { Input } from '@ui';

interface RangeProps {
  id: string;
  label?: string;
  outputId?: string;
  value: number;
  min?: number;
  max?: number;
  step?: number;
  onChange: (value: number) => void;
}

const Range: React.FC<RangeProps> = ({
  id,
  label = 'Slider',
  outputId,
  value,
  min = 0,
  max = 100,
  step = 1,
  onChange,
}) => {
  const safeValue = Number.isFinite(value) ? value : 0;
  const resolvedOutputId = outputId ?? `${id}-out`;

  return (
    <>
      <label htmlFor={id}>
        {label} <output id={resolvedOutputId}>{safeValue}</output>
      </label>
      <Input
        id={id}
        type='range'
        min={min}
        max={max}
        value={safeValue}
        step={step}
        onChange={(e) => onChange(Number(e.target.value))}
        style={
          {
            '--val': safeValue,
          } as React.CSSProperties
        }
      />
    </>
  );
};

export default Range;
